import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.regional.analysis');
import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import { RegionNode, RegionSelectionService } from 'src/app/region-selection.service';
import { PolicySimulationStateService } from 'src/app/policy-simulation-state.service';

@Component({
    selector: 'wiz-page-regional-analysis',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.regional.analysis/view.scss */
:host {
  display: block;
  min-height: 100%;
  background: #f4f6f8;
}

.regional-panel,
.regional-metrics,
.regional-empty {
  border: 1px solid #d7dde5;
  border-radius: 6px;
  background: #fff;
}

.regional-input-panel {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr)) auto;
  gap: 12px;
  align-items: end;
  padding: 16px;
}

.regional-input-panel label span {
  display: block;
  margin-bottom: 7px;
  color: #66717f;
  font-size: 10px;
  font-weight: 800;
}

.regional-input-panel select {
  width: 100%;
  min-height: 40px;
  border: 1px solid #cfd6df;
  border-radius: 4px;
  background: #fff;
  padding: 0 10px;
  color: #172231;
  font-size: 12px;
}

.regional-input-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.regional-input-actions button,
.regional-result-actions button {
  min-height: 40px;
  border: 0;
  border-radius: 4px;
  background: #2b5d87;
  padding: 0 16px;
  color: #fff;
  font-size: 11px;
  font-weight: 800;
}

.regional-input-actions button:disabled,
.regional-result-actions button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.regional-status {
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  border-radius: 999px;
  padding: 4px 9px;
  font-size: 10px;
  font-weight: 800;
  white-space: nowrap;
}

.regional-status.is-ready {
  background: #e7f5ec;
  color: #237447;
}

.regional-status.is-held {
  background: #fff2dc;
  color: #a15c0a;
}

.regional-status.is-error {
  background: #feecec;
  color: #b4232c;
}

.regional-status.is-neutral {
  background: #edf0f3;
  color: #657181;
}

.regional-empty,
.regional-loading {
  padding: 42px 20px;
  text-align: center;
  color: #66717f;
  font-size: 12px;
}

.regional-empty strong {
  display: block;
  color: #172231;
  font-size: 14px;
}

.regional-empty p {
  margin-top: 6px;
}

.regional-metrics {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

.regional-metrics article {
  padding: 18px 20px;
  border-right: 1px solid #e2e6eb;
}

.regional-metrics article:last-child {
  border-right: 0;
}

.regional-metrics span {
  color: #66717f;
  font-size: 10px;
  font-weight: 800;
}

.regional-metrics strong {
  display: block;
  margin-top: 8px;
  color: #172231;
  font-size: 22px;
}

.regional-result-panel {
  overflow: hidden;
}

.regional-result-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 20px;
  border-bottom: 1px solid #d7dde5;
}

.regional-result-head p {
  color: #2b5d87;
  font-size: 10px;
  font-weight: 800;
}

.regional-result-head h2 {
  margin-top: 5px;
  color: #172231;
  font-size: 16px;
  font-weight: 800;
}

.regional-hold-note {
  margin: 14px 20px 0;
  border: 1px solid #efc98e;
  border-radius: 5px;
  background: #fffbf3;
  padding: 12px 14px;
  color: #74470d;
  font-size: 11px;
}

.regional-hold-note p {
  margin-top: 4px;
  line-height: 1.6;
}

.regional-hold-facts {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}

.regional-hold-facts div {
  min-width: 112px;
  border: 1px solid #efc98e;
  border-radius: 4px;
  background: #fff;
  padding: 7px 9px;
}

.regional-hold-facts dt {
  color: #8b5b18;
  font-size: 9px;
}

.regional-hold-facts dd {
  margin-top: 2px;
  color: #172231;
  font-size: 11px;
  font-weight: 800;
}

.regional-alternatives {
  margin-top: 12px;
  border-top: 1px solid #efc98e;
  padding-top: 10px;
}

.regional-alternatives h3 {
  color: #172231;
  font-size: 11px;
  font-weight: 800;
}

.regional-alternatives ul {
  display: grid;
  gap: 6px;
  margin-top: 7px;
}

.regional-alternatives li {
  border-radius: 4px;
  background: #fff;
  padding: 8px 10px;
}

.regional-alternatives li strong,
.regional-alternatives li span {
  display: block;
}

.regional-alternatives li span {
  margin-top: 2px;
  color: #74470d;
}

.regional-table-wrap {
  overflow-x: auto;
}

.regional-result-table {
  width: 100%;
  min-width: 1180px;
  border-collapse: collapse;
  font-size: 11px;
  color: #334155;
}

.regional-result-table th {
  background: #f7f8fa;
  color: #66717f;
  font-size: 10px;
  font-weight: 800;
  text-align: left;
}

.regional-result-table th,
.regional-result-table td {
  padding: 12px 16px;
  border-bottom: 1px solid #e5e8ec;
  vertical-align: middle;
}

.regional-result-table td:first-child {
  color: #172231;
  font-weight: 800;
}

.regional-no-data {
  padding: 28px !important;
  text-align: center;
  color: #66717f !important;
}

.regional-result-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 14px 20px;
  background: #f7f8fa;
  color: #66717f;
  font-size: 10px;
}

.regional-action-buttons {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
}

.regional-action-buttons .is-secondary {
  border: 1px solid #cfd6df;
  background: #fff;
  color: #334155;
}

.regional-alert {
  border-radius: 5px;
  padding: 12px 14px;
  font-size: 11px;
}

.regional-alert--error {
  border: 1px solid #f3b6ba;
  background: #fff1f1;
  color: #a61b27;
}

.regional-alert--held {
  border: 1px solid #efc98e;
  background: #fffbf3;
  color: #74470d;
}

.regional-alert--held p {
  margin-top: 4px;
}

.regional-source-note {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  color: #788390;
  font-size: 10px;
}

.policy-state-signals {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 0 20px 14px;
}

.policy-state-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  min-height: 28px;
  border: 1px solid currentColor;
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 10px;
  font-weight: 800;
  white-space: normal;
}

.policy-state-chip.is-success {
  background: #e7f5ec;
  color: #237447;
}

.policy-state-chip.is-pending {
  background: #fff2dc;
  color: #8a4f08;
}

.policy-state-chip.is-blocked {
  background: #eef2f6;
  color: #475569;
}

.policy-state-chip.is-warning {
  background: #fff4e5;
  color: #9a4d00;
}

.policy-state-chip.is-info {
  background: #edf5fb;
  color: #255d85;
}

.policy-state-chip.is-scope {
  background: #f1f5f9;
  color: #526171;
}

.policy-status-legend {
  padding: 16px 20px;
}

.policy-status-legend summary {
  cursor: pointer;
  color: #2b5d87;
  font-size: 11px;
  font-weight: 800;
}

.policy-status-legend__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  margin-top: 14px;
}

.policy-status-legend__grid article {
  min-width: 0;
  border: 1px solid #e2e6eb;
  border-radius: 5px;
  padding: 10px;
}

.policy-status-legend__grid code {
  display: block;
  margin-top: 7px;
  overflow-wrap: anywhere;
  color: #334155;
  font-size: 9px;
}

.policy-status-legend__grid p {
  margin-top: 5px;
  color: #66717f;
  font-size: 9px;
  line-height: 1.5;
}

@media (max-width: 980px) {
  .regional-input-panel {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .regional-input-actions {
    grid-column: 1/-1;
    justify-content: flex-end;
  }
}
@media (max-width: 640px) {
  .regional-input-panel {
    grid-template-columns: 1fr;
  }
  .regional-input-actions {
    grid-column: auto;
    justify-content: space-between;
  }
  .regional-metrics {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .regional-metrics article {
    border-bottom: 1px solid #e2e6eb;
  }
  .regional-metrics article:nth-child(2n) {
    border-right: 0;
  }
  .regional-metrics article:last-child {
    grid-column: 1/-1;
  }
  .regional-result-actions,
  .regional-source-note {
    align-items: flex-start;
    flex-direction: column;
  }
  .regional-action-buttons {
    width: 100%;
    justify-content: stretch;
  }
  .regional-action-buttons button {
    width: 100%;
  }
  .regional-input-actions button,
  .regional-result-actions button {
    min-height: 44px;
  }
  .policy-status-legend__grid {
    grid-template-columns: 1fr;
  }
}`],
})
export class PageRegionalAnalysisComponent implements OnInit {
    public config: any = {
        meta: null,
        region_tree: { meta: null, regions: [] },
        industries: [],
        goals: [],
        default_weights: {},
        default_goal_key: 'GROWTH_PROMOTION',
    };
    public selectedMetropolitanId: string = '';
    public selectedBasicId: string = '';
    public selectedIndustryCode: string = '';
    public selectedGoalKey: string = 'GROWTH_PROMOTION';
    public weights: any = {
        specialization: 3,
        employment: 3,
        growth: 3,
        urgency: 3,
        feasibility: 3,
    };
    public result: any = null;
    public loading: boolean = true;
    public analyzing: boolean = false;
    public errorMessage: string = '';
    private requestedParentRegionId: string = '';

    constructor(@Inject( Service)         public service: Service,@Inject( RegionSelectionService)         public regionSelection: RegionSelectionService,@Inject( PolicySimulationStateService)         public policyState: PolicySimulationStateService,@Inject( Router)         private router: Router,    ) { }

    public async ngOnInit() {
        await this.service.init();
        await this.regionSelection.loadTree();
        await this.loadConfig();
        this.restoreInputs();
        if (this.selection && this.selectedIndustryCode) {
            await this.runAnalysis();
        }
        this.loading = false;
        await this.service.render();
    }

    public get metropolitanRegions(): RegionNode[] {
        return this.config?.region_tree?.regions || [];
    }

    public get basicRegions(): RegionNode[] {
        const parent = this.metropolitanRegions.find(item => item.region_id === this.selectedMetropolitanId);
        return parent?.children || [];
    }

    public get selection() {
        return this.regionSelection.selection;
    }

    public get canAnalyze(): boolean {
        return !!this.selection?.region_id
            && this.selection.analysis_status === 'READY'
            && !!this.selectedIndustryCode;
    }

    public publicResultAvailable(): boolean {
        const status = this.result?.status;
        return status?.policy_ready === true
            && ['POLICY_READY', 'RECOMMENDATION_AVAILABLE'].includes(status.primary_status || status.code)
            && (!Array.isArray(status.blocking_reasons) || status.blocking_reasons.length === 0);
    }

    public get publicIndustryRows(): any[] {
        if (!this.publicResultAvailable()) return [];
        return (this.result?.industries || []).filter((row: any) => row.policy_ready === true);
    }

    public async changeMetropolitan(event: any) {
        this.selectedMetropolitanId = event?.target?.value || '';
        this.selectedBasicId = '';
        this.requestedParentRegionId = '';
        this.resetResult();
        if (!this.selectedMetropolitanId) this.regionSelection.clear();
        else this.regionSelection.selectByRef(this.selectedMetropolitanId);
        await this.service.render();
    }

    public async changeBasic(event: any) {
        this.selectedBasicId = event?.target?.value || '';
        this.resetResult();
        const regionId = this.selectedBasicId || this.selectedMetropolitanId;
        if (regionId) this.regionSelection.selectByRef(regionId);
        this.requestedParentRegionId = this.regionSelection.selection?.parent_region_id || '';
        await this.service.render();
    }

    public async changeIndustry(event: any) {
        this.selectedIndustryCode = event?.target?.value || '';
        this.resetResult();
        await this.service.render();
    }

    public async runAnalysis() {
        if (!this.canAnalyze) return;
        this.analyzing = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('analysis', {
                reference_year: this.referenceYear,
                region_id: this.selection.region_id,
                parent_region_id: this.requestedParentRegionId || this.selection.parent_region_id || '',
                industry_code: this.selectedIndustryCode,
            });
            if (code !== 200 || !data?.selection || !data?.metrics || !data?.status) {
                throw new Error(data?.message || '지역 분석 결과의 필수 필드를 확인하지 못했습니다.');
            }
            this.result = data;
        } catch (error) {
            this.result = null;
            this.errorMessage = error?.message || '지역 분석 중 오류가 발생했습니다.';
        } finally {
            this.analyzing = false;
            await this.service.render();
        }
    }

    public openPolicySimulator() {
        if (!this.result) return;
        this.savePolicyInput();
        void this.router.navigate(['/policy-simulator']);
    }

    public openPolicyRecommendation() {
        if (!this.result) return;
        this.savePolicyInput();
        void this.router.navigate(['/policy-recommendation']);
    }

    public openDistribution() {
        void this.router.navigate(['/specialization-distribution']);
    }

    public statusText(): string {
        if (!this.result) return this.canAnalyze ? '분석 조건 확인' : '입력 대기';
        return this.publicResultAvailable() ? '정책 결과 제공' : '상세 결과 준비 중';
    }

    public statusClass(): string {
        if (!this.result) return 'is-neutral';
        return this.publicResultAvailable() ? 'is-ready' : 'is-neutral';
    }

    public focusIndustrySelector() {
        document.getElementById('regional-industry-select')?.focus();
    }

    public statusLegend(): any[] {
        const statuses = this.config?.policy_status_registry?.statuses || {};
        return Object.keys(statuses).map(code => ({ code, ...statuses[code] }));
    }

    public formatCount(value: number | null | undefined): string {
        return value === null || value === undefined ? '-' : Number(value).toLocaleString('ko-KR');
    }

    public formatLq(value: number | null | undefined): string {
        return value === null || value === undefined ? '-' : Number(value).toFixed(2);
    }

    public formatGrowth(value: number | null | undefined): string {
        if (value === null || value === undefined) return '검증 대기';
        const numeric = Number(value);
        return `${numeric > 0 ? '+' : ''}${numeric.toFixed(2)}%`;
    }

    public readinessText(value: boolean): string {
        return value ? 'true' : 'false';
    }

    private get referenceYear(): number | null {
        return this.config.meta?.reference_year || this.config.meta?.year || null;
    }

    private async loadConfig() {
        try {
            const { code, data } = await wiz.call('config', {
                reference_year: this.regionSelection.referenceYear,
            });
            if (code !== 200 || !data?.region_tree || !Array.isArray(data?.industries)) {
                throw new Error(data?.message || '분석 설정의 필수 필드를 확인하지 못했습니다.');
            }
            this.config = data;
            this.selectedGoalKey = data.default_goal_key || 'GROWTH_PROMOTION';
            this.weights = { ...data.default_weights };
        } catch (error) {
            this.errorMessage = error?.message || '지역 분석 설정을 불러오지 못했습니다.';
        }
    }

    private restoreInputs() {
        const query = new URLSearchParams(window.location.search);
        const stored = this.policyState.read();
        const requestedRegionId = query.get('region_id');
        const regionId = requestedRegionId !== null
            ? requestedRegionId
            : (this.regionSelection.selection?.region_id || stored?.input?.region_id || '');
        const requestedIndustry = query.get('industry_code');
        const industryCode = requestedIndustry !== null
            ? requestedIndustry
            : (stored?.input?.industry_code || '');
        const goalKey = query.has('policy_goal') || query.has('goal_key')
            ? (query.get('policy_goal') || query.get('goal_key') || '')
            : (stored?.input?.goal_key || this.config.default_goal_key);
        const node = regionId ? this.regionSelection.resolve(regionId) : null;
        if (node?.analysis_status === 'READY') {
            this.regionSelection.select(node);
        } else if (requestedRegionId !== null) {
            this.regionSelection.clear();
            if (node) this.regionSelection.block(node);
        }
        const selection = this.regionSelection.selection;
        if (selection?.region_type === 'METROPOLITAN') {
            this.selectedMetropolitanId = selection.region_id;
            this.selectedBasicId = '';
        } else if (selection?.region_type === 'BASIC') {
            this.selectedMetropolitanId = selection.parent_region_id || '';
            this.selectedBasicId = selection.region_id;
        }
        this.requestedParentRegionId = query.has('parent_region_id')
            ? (query.get('parent_region_id') || '')
            : (stored?.input?.parent_region_id || selection?.parent_region_id || '');
        if (this.config.industries.some((item: any) => item.code === industryCode)) {
            this.selectedIndustryCode = industryCode;
        }
        if (this.config.goals.some((item: any) => item.key === goalKey)) {
            this.selectedGoalKey = goalKey;
        }
        Object.keys(this.weights).forEach(key => {
            const queryKey = `weight_${key}`;
            const value = query.has(queryKey)
                ? Number(query.get(queryKey))
                : Number(stored?.input?.weights?.[key]);
            if (Number.isInteger(value) && value >= 1 && value <= 5) this.weights[key] = value;
        });
    }

    private savePolicyInput() {
        if (!this.selection || !this.result?.selection) return;
        const industry = this.config.industries.find((item: any) => item.code === this.selectedIndustryCode);
        this.policyState.save(this.selection, {
            region_id: this.result.selection.region_id,
            region_name: this.result.selection.region_name,
            region_type: this.result.selection.region_type,
            parent_region_id: this.requestedParentRegionId || this.result.selection.parent_region_id,
            industry_code: this.selectedIndustryCode,
            industry_name: industry?.name || this.result.selection.industry_name || '',
            goal_key: this.selectedGoalKey,
            policy_goal: this.selectedGoalKey,
            weights: { ...this.weights },
            data_year: this.result.selection.data_year,
        }, null);
    }

    private resetResult() {
        this.result = null;
        this.errorMessage = '';
    }
}

export default PageRegionalAnalysisComponent;